module.exports = __webpack_public_path__ + "static/img/cf0971014e9dae7ffb2efddfab337ef.72acb81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cf0971014e9dae7ffb2efddfab337ef.jpg
// module id = g7yB
// module chunks = 0